export default __webpack_public_path__ + "static/media/banner-mobile-bg-blue2-template.375146a4.svg";